<template>
  <div
    class="image"
    :style="backgroundImage"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div>
      <i
        v-if="showListIcon"
        class="fas fa-list-ol position-absolute list-icon"
      ></i>
      <span v-if="playlist.featured" class="tag tag--playlist-icon">
        {{ $t('PRODUCTS.LABELS.FEATURED_PLAYLIST') }}
      </span>
    </div>
    <i
      v-if="hover && showPlayIcon"
      class="fas fa-play-circle play-circle fa-5x d-flex justify-content-center align-items-center h-100"
    ></i>
    <div
      v-if="!backgroundImage"
      class="d-flex justify-content-center align-items-center h-100"
    >
      <h2>
        <i class="fas fa-list-ol c-brand-color pt-3"></i>
      </h2>
    </div>
  </div>
</template>

<script lang="ts">
import { getDefaultThumbnailForMediaType } from '@/utils/media';

export default {
  name: 'PlaylistStudentThumbnail',
  data() {
    return {
      hover: false,
    };
  },
  props: {
    playlist: {
      type: Object,
    },
    showListIcon: {
      type: Boolean,
      default: false,
    },
    showPlayIcon: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
    },
  },
  computed: {
    backgroundImage(): object | null {
      const media = this.playlist?.cover_file || this.playlist?.media;
      const thumbnailUrl =
        media?.thumbnail ||
        getDefaultThumbnailForMediaType(
          this.playlist?.media?.file_content || this.source
        );

      if (!thumbnailUrl) return null;

      const res = {
        backgroundImage: 'url(' + thumbnailUrl + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      };

      if (media && media.focal_point_x && media.focal_point_y) {
        const { focal_point_x, focal_point_y } = media;
        res.backgroundPosition = `${focal_point_x}% ${focal_point_y}%`;
      }

      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

$tags-offset: 6px;
$tag-height: 26px;

.tag {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: $border-radius;
  color: $white;
  height: $tag-height;
  padding: 2px 9px;
  font-size: 0.75rem;

  &--playlist-icon {
    padding: 5px;
    top: $tags-offset;
    left: 36px;
    background-color: rgba($black, 0.5);
    width: auto;
  }
}

.image {
  border-radius: 0.375rem;
  background-color: var(
    --brand-color-with-opacity-03,
    rgba($light-bubblegum, 0.3)
  );
  transition: all 0.3s ease-in-out;
  @include media-breakpoint-down(sm) {
    border-radius: 0;
  }
}

.list-icon {
  left: 0;
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.5rem;
  padding: 4px;
  cursor: pointer;
  color: white;
  background: $charcoal;
  border-radius: 4px;
  z-index: 1;

  &:hover {
    background-color: var(--brand-color, $coral);
  }
}

.play-circle:hover {
  color: var(--brand-color, $coral);
}
</style>
